<template>
  <main-layout wide>
    <base-card medium>
      <div class="grid">
        <catalog-filter-container class="left-col" />
        <div>
          <catalog-product-single-container />
        </div>
        <!-- <catalog-product-list-container :selectable="false" style="margin-top: 10px" /> -->
      </div>
    </base-card>
  </main-layout>
</template>

<script>
// import CatalogProductSingle from '@/components/Widgets/Catalog/CatalogProductSingle';
import CatalogFilterContainer from '@/components/Widgets/Catalog/CatalogFilterContainer';
import CatalogProductSingleContainer from '@/components/Widgets/Catalog/CatalogProductSingleContainer';

export default {
  name: 'CatalogShow',
  components: {
    CatalogFilterContainer,
    CatalogProductSingleContainer,
    // CatalogProductSingle,
  },
};
</script>

<style lang="scss" scoped>
.grid{
    display: grid;
    grid-gap: 20px;

    @media (min-width: map-get($breakpoints,'lg')) {
        grid-template-columns: 200px 1fr;
    }

}
.left-col{
    margin-top: 60px;
    display: none;

    @media (min-width: map-get($breakpoints,'lg')) {
        display: block;
    }
}
</style>
